import { useMemo } from 'react';
import { IQueryLike } from '../../components/QueriesLoaded';

export const useQueriesData = (queries: IQueryLike<any>[]) => {
  return useMemo(() => {
    return queries.every((p) => !!p.data);
  }, [queries]);
};
